export default __webpack_public_path__ + "static/media/icon_calendar.ba5460ef.webp";